var React = require('react');

function CloseAlt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 1L1 7","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7 7L1 1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CloseAlt.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 8 8","fill":"none"};

module.exports = CloseAlt;

CloseAlt.default = CloseAlt;
